import React, { memo, useState, useRef, useCallback, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useProjectId from '@hooks/useProjectId';
import PendoIO from '@utils/pendo';
import { colorsMapping } from '@components/colorSelector/colorSelector';
import { typeMapping_list } from './typeMapping';
// import '@style/components/integrationList.scss';
import '../../../../styles/components/integrationList.scss';

const IntegrationListView = (props) => {
  const { tabName, dataList, listOpen } = props;

  const [colDefs, setColDefs] = useState([
    {
      headerName: '',
      field: 'color',
      suppressMovable: true,
      width: 12,
      headerClass: 'listviwe-table-header-row',
      cellStyle: (params) => ({
        background: colorsMapping[params.value],
        color: colorsMapping[params.value],
      }),
    },
    {
      headerName: '',
      field: 'type',
      suppressMovable: true,
      width: 48,
      headerClass: 'listviwe-table-header-row',
      cellStyle: {
        color: 'var(--fontColor)',
        // paddingLeft: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1rem',
      },
      cellRenderer: (props) => (
        <span
          className={`appkiticon ${
            typeMapping_list[props.value] || typeMapping_list.text
          }`}
        />
      ),
    },
    {
      headerName: 'Name',
      field: 'module',
      suppressMovable: true,
      width: 240,
      headerClass: 'listviwe-table-header-row',
      cellClass: 'customize-cell',
      cellStyle: {
        color: 'var(--fontColor)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        fontSize: '1rem',
      },
    },
    {
      headerName: 'Description',
      field: 'description',
      suppressMovable: true,
      flex: 1,
      headerClass: 'listviwe-table-header-row',
      cellClass: 'customize-cell',
      cellStyle: {
        color: 'var(--fontColor)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        fontSize: '1rem',
      },
    },
    { headerName: '', field: 'moduleId', suppressMovable: true, hide: true },
    { headerName: '', field: 'link', suppressMovable: true, hide: true },
    { headerName: '', field: 'iframe', suppressMovable: true, hide: true },
  ]);

  const gridRef = useRef(null);

  const history = useHistory();
  const projectId = useProjectId();
  const userId = useSelector((state) => state.login.userInfo.guid);
  const userName = useSelector(
    (state) =>
      `${state.login.userInfo.given_name} ${state.login.userInfo.family_name}`,
  );

  const handleLinkClick = (rowData) => {
    const { moduleId, link, module, iframe, type } = rowData;

    if (!link) {
      return;
    }

    PendoIO.track('Navigation Tiles - Access', {
      project_id: projectId,
      uid: userId,
      full_name: userName,
      section_name: module,
      tab_name: tabName,
    });

    const _link =
      link.trim().indexOf('http://') === 0 ||
      link.trim().indexOf('https://') === 0
        ? link
        : `https://${link}`;

    if ((type === 'text' && iframe) || type === 'powerbi') {
      const search = new URLSearchParams({
        integrationModuleId: moduleId,
        moduleName: module,
        from: 'tiles',
        type,
        // spnId,
        projectId,
      });
      history.push(`/projects/powerBI?${search.toString()}`);
      return;
    } else if (type === 'textContainer') {
      const search = new URLSearchParams({
        projectId,
        from: 'tiles',
        moduleName: module,
        integrationModuleId: moduleId,
      });
      history.push(`/textContainer?${search.toString()}`);
      return;
    } else if (type === 'M365') {
      const search = new URLSearchParams({
        integrationModuleId: moduleId,
        moduleName: module,
        from: 'tiles',
        type,
        projectId,
        M365: true,
      });
      history.push(`/link?${search.toString()}`);
      return;
    } else if (iframe) {
      const search = new URLSearchParams({
        projectId,
        from: 'tiles',
        moduleName: module,
        integrationModuleId: moduleId,
      });
      history.push(
        `/projects/${
          type === 'pdf' ? 'link' : 'imageLink'
        }?${search.toString()}`,
      );
      return;
    }

    try {
      window.open(_link);
    } catch (e) {
      window.open('http://Invalid link');
    }
  };

  console.log('dataList : ', dataList, '||', colDefs);

  return (
    <div
      className={listOpen ? 'listview-open' : 'listview'}
      style={
        listOpen
          ? { height: `${dataList ? (dataList.length + 1) * 36 : 0}px` }
          : {}
      }
    >
      <AgGridReact
        ref={gridRef}
        rowData={dataList}
        columnDefs={colDefs}
        defaultColDef={colDefs}
        rowHeight={36}
        rowClass="listviwe-table-row"
        onRowClicked={(event) => {
          handleLinkClick(event.data);
        }}
      />
    </div>
  );
};

export default memo(IntegrationListView);
